import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigacabbookinginpune() {



const cardData =
  {
    keyword: 'Ertiga Cab Booking in Pune',
    heading: 'Sanavi Travels: Ertiga Cab Booking in Pune',
    headingDescription: 'Sanavi Travels offers professional, comfortable, and affordable Ertiga Cab Booking in Pune for families, corporate travelers, tourists, and daily commuters. The Maruti Suzuki Ertiga is one of the most preferred MPVs in Pune due to its spacious seating, smooth ride quality, excellent mileage, and suitability for both city and highway travel. Ertiga cabs are ideal for airport transfers, railway station drops, wedding travel, corporate movement, local sightseeing, and outstation trips from Pune. With ample legroom, large boot space for luggage, and comfortable seating for up to six passengers, Ertiga cabs provide the perfect balance of comfort and affordability. Sanavi Travels maintains a fleet of clean, well-serviced AC and Non-AC Ertiga vehicles driven by experienced chauffeurs who are familiar with Pune city routes, highways, and tourist destinations. With transparent pricing, flexible booking options, punctual pickups, and 24/7 customer support, Sanavi Travels ensures a smooth, safe, and stress-free Ertiga cab experience across Pune and beyond.',

    top: 'Popular Uses for Ertiga Cab Booking in Pune',


"topPlaces": [
  {
    "title": "Ertiga Cab for Airport Transfers",
    "description": "Ertiga cabs are widely used for Pune airport pickups and drops due to their spacious boot space and comfortable seating. Families and corporate travelers prefer Ertiga cabs for airport travel as they can accommodate passengers and luggage easily while ensuring timely and stress-free transfers."
  },
  {
    "title": "Ertiga Cab for Railway Station Travel",
    "description": "Passengers traveling to Pune railway stations often choose Ertiga cabs for their reliability and comfort. The vehicle offers smooth rides through city traffic, sufficient luggage space, and a relaxed travel experience for long-distance train journeys."
  },
  {
    "title": "Outstation Travel from Pune",
    "description": "Ertiga cabs are ideal for outstation travel from Pune to destinations such as Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, Kolhapur, and Satara. The vehicle’s comfort and stability make it suitable for long highway journeys."
  },
  {
    "title": "Wedding and Family Functions",
    "description": "For weddings and family events, Ertiga cabs provide comfortable group transportation for relatives and guests. The vehicle’s premium look and spacious interiors make it a preferred choice for special occasions."
  },
  {
    "title": "Corporate Travel in Pune",
    "description": "Corporate professionals often use Ertiga cabs for meetings, office travel, client visits, and conferences. The professional appearance and comfortable seating ensure a smooth corporate travel experience."
  },
  {
    "title": "Local Sightseeing in Pune",
    "description": "Tourists and families prefer Ertiga cabs for local sightseeing around Pune, offering comfortable travel between attractions without fatigue."
  },
  {
    "title": "Family Trips and Vacations",
    "description": "Ertiga cabs are perfect for family vacations as they offer enough space for passengers, children, and luggage while maintaining comfort throughout the journey."
  },
  {
    "title": "Daily and Occasional City Travel",
    "description": "For city rides, shopping trips, and personal travel, Ertiga cabs offer convenience, safety, and affordability."
  },
  {
    "title": "Long-Distance Highway Travel",
    "description": "Ertiga’s smooth suspension and stable handling make it suitable for expressway and highway travel from Pune."
  },
  {
    "title": "Flexible One-Day and Multi-Day Trips",
    "description": "Ertiga cabs can be booked for single-day outings or multi-day trips, offering flexibility and comfort for all travel plans."
  }
]
,



"services": [
{
"name": "Ertiga Cab Booking in Pune",
"description": "Ertiga Cab Booking in Pune provides a comfortable and economical travel solution for families, corporate travelers, and tourists. The Ertiga offers spacious seating, smooth ride quality, and sufficient luggage space, making it suitable for city travel as well as long-distance journeys. Sanavi Travels ensures clean vehicles, professional drivers, punctual service, and transparent pricing, delivering a hassle-free cab booking experience."
},
{
"name": "Ertiga on Rent Pune",
"description": "Ertiga on Rent Pune allows travelers to enjoy flexible rental options for short trips, full-day bookings, and multi-day journeys. This service is ideal for local travel, sightseeing, weddings, and outstation trips, offering comfort and affordability."
},
{
"name": "AC Ertiga Cab Hire Pune",
"description": "AC Ertiga Cab Hire Pune ensures a cool and relaxing journey, especially during summer and long-distance travel. Air-conditioned Ertiga cabs are preferred for airport transfers, corporate travel, and premium family trips."
},
{
"name": "Non AC Ertiga Cab Rental Pune",
"description": "Non AC Ertiga Cab Rental Pune is a budget-friendly option for short-distance travel and economical bookings while maintaining safety and comfort."
},
{
"name": "Ertiga Cab for Airport Pune",
"description": "Ertiga Cab for Airport Pune offers timely pickups, smooth rides, and ample luggage space, ensuring stress-free airport transfers."
},
{
"name": "Ertiga Cab for Railway Station Pune",
"description": "Ertiga Cab for Railway Station Pune provides reliable and punctual transfers for passengers traveling with luggage and families."
},
{
"name": "Ertiga Cab for Wedding Pune",
"description": "Ertiga Cab for Wedding Pune is suitable for transporting wedding guests, relatives, and families comfortably during ceremonies and events."
},
{
"name": "Ertiga Cab for Corporate Pune",
"description": "Ertiga Cab for Corporate Pune supports business travel, meetings, and office commutes with professional service and clean vehicles."
},
{
"name": "Ertiga Cab for Outstation Pune",
"description": "Ertiga Cab for Outstation Pune offers dependable long-distance travel with experienced drivers and comfortable seating."
},
{
"name": "Affordable Ertiga Cab Hire Pune",
"description": "Affordable Ertiga Cab Hire Pune delivers cost-effective travel solutions without compromising on vehicle quality or service standards."
},
{
"name": "Best Ertiga Cab Service Pune",
"description": "Best Ertiga Cab Service Pune by Sanavi Travels is trusted for reliability, comfort, transparent pricing, and professional chauffeurs."
},
{
"name": "Ertiga Cab with Driver Pune",
"description": "Ertiga Cab with Driver Pune includes experienced drivers who manage navigation, traffic, and timing for a smooth journey."
},
{
"name": "Ertiga Cab for Local Sightseeing Pune",
"description": "Ertiga Cab for Local Sightseeing Pune allows families and tourists to explore Pune comfortably without travel fatigue."
},
{
"name": "Ertiga Cab for Family Trip Pune",
"description": "Ertiga Cab for Family Trip Pune is ideal for family outings and vacations, offering comfort, space, and safety."
},
{
"name": "Luxury Ertiga Cab Hire Pune",
"description": "Luxury Ertiga Cab Hire Pune provides premium travel experience with well-maintained vehicles and courteous drivers for special occasions."
}
],
"tableData": [
["Ertiga Cab Booking in Pune", "Ertiga on Rent Pune"],
["AC Ertiga Cab Pune", "Non AC Ertiga Cab Pune"],
["Ertiga Airport Cab Pune", "Ertiga Railway Cab Pune"],
["Ertiga Wedding Cab Pune", "Ertiga Corporate Cab Pune"],
["Ertiga Outstation Cab Pune", "Ertiga Family Trip Cab Pune"],
["Affordable Ertiga Cab Pune", "Best Ertiga Cab Service Pune"],
["Luxury Ertiga Cab Pune", "Ertiga Cab with Driver Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Ertiga Cab Booking in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers trusted and comfortable Ertiga cab services across Pune."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Vehicle",
    "WhyChoosedescription": "Ertiga offers ample space and comfort for families and groups."
  },
  {
    "WhyChooseheading": "Experienced Drivers",
    "WhyChoosedescription": "Professional chauffeurs ensure safe and punctual travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing",
    "WhyChoosedescription": "Transparent pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "Multiple Travel Options",
    "WhyChoosedescription": "Local, airport, outstation, wedding, and corporate travel supported."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cars",
    "WhyChoosedescription": "Vehicles are cleaned and sanitized before every trip."
  },
  {
    "WhyChooseheading": "24/7 Booking Support",
    "WhyChoosedescription": "Customer support available round the clock."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "On-time pickups and smooth journey execution."
  }
]

}

const faqData = [
  {
    question: 'Do you provide Ertiga cab booking in Pune?',
    answer: 'Yes, Sanavi Travels offers Ertiga cab booking services across Pune.'
  },
  {
    question: 'Are AC Ertiga cabs available?',
    answer: 'Yes, both AC and Non-AC Ertiga cabs are available.'
  },
  {
    question: 'Can I book an Ertiga cab for outstation travel?',
    answer: 'Yes, Ertiga cabs are available for outstation and long-distance journeys.'
  },
  {
    question: 'Is the driver included in Ertiga cab booking?',
    answer: 'Yes, all Ertiga cab bookings include professional drivers.'
  },
  {
    question: 'Is Ertiga suitable for family travel?',
    answer: 'Yes, Ertiga is ideal for family trips due to its comfort and space.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rakesh Jadhav',
    feedback: 'Booked an Ertiga cab in Pune for airport travel. Very comfortable and punctual service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Sneha Kulkarni',
    feedback: 'Great Ertiga cab service for our family outstation trip. Smooth ride and polite driver.',
    rating: 5
  }
];



























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








// const jsonData = {
// "@context": "https://schema.org",
// "@type": "Service",
// "name": "Ertiga Cab Booking in Pune",
// "serviceType": "Ertiga Taxi Rental Service",
// "provider": {
// "@type": "LocalBusiness",
// "name": "Sanavi Travels",
// "telephone": "+91 7387507373"
// },
// "areaServed": {
// "@type": "City",
// "name": "Pune"
// },
// "description":
// "Book Ertiga cab in Pune for airport transfers, local travel, corporate trips and outstation journeys. Comfortable 6+1 seater SUV with professional driver.",
// "aggregateRating": {
// "@type": "AggregateRating",
// "ratingValue": 4.7,
// "bestRating": 5,
// "worstRating": 1,
// "ratingCount": 10000
// }
// };




const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/ertiga-cab-booking-in-pune#service",

  "name": "Ertiga Cab Booking in Pune",

  "serviceType": "Maruti Ertiga Cab Service",

  "description":
    "Sanavi Travels offers Ertiga cab booking in Pune for local travel, airport transfers, corporate travel, family trips, weddings and outstation journeys with professional drivers.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune",
    "containedInPlace": {
      "@type": "State",
      "name": "Maharashtra",
      "containedInPlace": {
        "@type": "Country",
        "name": "India"
      }
    }
  },

  "url":
    "https://www.sanavitravels.com/ertiga-cab-booking-in-pune"
};





  return (
    <div>


<Helmet>
  <title>
    Ertiga Cab Booking in Pune | Maruti Ertiga Rental | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book an Ertiga cab in Pune with Sanavi Travels for local travel, airport transfers, corporate trips, family travel, weddings and outstation journeys with a professional driver."
  />

  <meta
    name="keywords"
    content="Ertiga Cab Booking in Pune, Ertiga Cab Pune, Ertiga Rental Pune, Maruti Ertiga Taxi Pune, Ertiga Hire Pune, Ertiga for Outstation Pune, Ertiga Airport Cab Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/ertiga-cab-booking-in-pune"
  />

  {/* Open Graph */}
  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="Ertiga Cab Booking in Pune | Maruti Ertiga Rental | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Book an Ertiga cab in Pune for local travel, airport transfers, family trips, corporate travel, weddings and outstation journeys with Sanavi Travels."
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/ertiga-cab-booking-in-pune"
  />

  <meta
    property="og:image"
    content="https://www.sanavitravels.com/images/ertiga-cab-booking-in-pune.jpg"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

{/* <Helmet>
  <title>
    Ertiga Cab Booking in Pune | 6+1 Seater SUV Taxi | Sanavi Travels
  </title>

<meta
 name="description"
 content="Book Ertiga Cab Booking in Pune with Sanavi Travels. Affordable 6+1 seater SUV taxi for airport pickup, local travel, corporate trips and outstation tours with professional drivers."
/>

<meta
 name="keywords"
 content="Ertiga Cab Booking in Pune, Ertiga Taxi Pune, Ertiga on Rent Pune, Ertiga Cab Service Pune, Maruti Ertiga Cab Pune, Pune Ertiga Rental, SUV Cab Pune, Pune Airport Ertiga Cab"
/>

  <link
    rel="canonical"
    href="https://www.yourdomain.com/ertiga-cab-booking-in-pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>

</Helmet> */}


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/ertiga-cab-booking-in-pune.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigacabbookinginpune;